import isEmpty from 'lodash/fp/isEmpty'

export const parseQueryParams = filters =>
    filters ? Object.entries(filters).map(([key, value]) => !isEmpty(value) ? `${key}=${value}` : '').join('&') : ''